module.exports = vendor_889db276c7ac5f6ab036;


//////////////////
// WEBPACK FOOTER
// external "vendor_889db276c7ac5f6ab036"
// module id = heQT
// module chunks = 25